var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "exhibitor-registration-component" }, [
    !_vm.toAnchor
      ? _c("h1", [
          _vm._v(
            "\n        " +
              _vm._s(
                !_vm.allReadOnly
                  ? _vm.translations.title
                  : _vm.translations.titleValidated
              ) +
              "\n    "
          ),
        ])
      : _c("h1", [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.toAnchor === "validated"
                  ? _vm.translations.titleValidated
                  : _vm.translations.titleWithAnchor
              ) +
              "\n    "
          ),
        ]),
    _vm._v(" "),
    _c("h2", { staticClass: "with-deco" }, [
      _vm._v("\n        " + _vm._s(_vm.translations.categoryTitle) + "\n    "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "categories" },
      _vm._l(_vm.categories, function (category) {
        return _c("div", { key: category.id }, [
          category.extra_attributes.redirect_other_route
            ? _c(
                "a",
                {
                  class: `block no-underline category-item ${
                    category.id === _vm.selectedCategoryId ? "is-selected" : ""
                  }
                    ${_vm.hasId ? "read-only" : ""}`,
                  attrs: { href: !_vm.hasId ? _vm.otherRoute : null },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(category.title) +
                      "\n            "
                  ),
                ]
              )
            : _c(
                "div",
                {
                  class: `category-item ${
                    category.id === _vm.selectedCategoryId ? "is-selected" : ""
                  }
                    ${_vm.hasId ? "read-only" : ""}`,
                  on: {
                    click: function ($event) {
                      return _vm.selectCategory(category.id)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(category.title) +
                      "\n            "
                  ),
                ]
              ),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { attrs: { id: "form" } }, [
      this.selectedCategoryId
        ? _c(
            "form",
            {
              attrs: { enctype: "multipart/form-data" },
              on: { submit: (e) => _vm.sumbitForm(e) },
            },
            [
              _c("h2", { staticClass: "with-deco" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.translations.exhibitorFormTitle) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _vm.selectedCategoryId === _vm.showWarningFor
                ? _c("div", { ref: "checkboxesLoginForm" }, [
                    _c("div", { staticClass: "warning" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.translations.warningMessage) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "create-exhibitor-form login-form" },
                      [
                        _c(
                          "div",
                          { staticClass: "my-4 form-group form-group-radio" },
                          [
                            _c("label", { attrs: { for: "list-status-1" } }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.exhibitor.listStatus,
                                    expression: "exhibitor.listStatus",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  id: "list-status-1",
                                  disabled: _vm.allReadOnly,
                                },
                                domProps: {
                                  value: 1,
                                  checked: _vm._q(_vm.exhibitor.listStatus, 1),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.exhibitor,
                                      "listStatus",
                                      1
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", {
                                class: `checkmark checkbox ${
                                  this.newlyCreated &&
                                  _vm.exhibitor.listStatus === null
                                    ? "highlighted"
                                    : ""
                                }`,
                              }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.translations.formLabels.listStatus1
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.exhibitor.listStatus === 1
                          ? _c("div", { staticClass: "upload-form" }, [
                              _c(
                                "label",
                                {
                                  class: `${
                                    this.newlyCreated &&
                                    _vm.exhibitor.listStatus === 1 &&
                                    (!_vm.existing ||
                                      !_vm.existing.classification)
                                      ? "highlighted"
                                      : ""
                                  }`,
                                  attrs: { for: "classification" },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.translations.formLabels
                                          .uploadClassification
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.existing &&
                              _vm.existing.classification &&
                              !_vm.showUpload.includes("classification")
                                ? _c(
                                    "div",
                                    { staticClass: "existing-actions" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "button mr-2",
                                          on: {
                                            click: function ($event) {
                                              return _vm.download(
                                                _vm.existing.classification
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.translations.formLabels
                                                  .download
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.allReadOnly
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "button",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleShowUpload(
                                                    "classification"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.translations.formLabels
                                                      .updateDocument
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !(_vm.existing && _vm.existing.classification) ||
                              _vm.showUpload.includes("classification")
                                ? _c("div", [
                                    _c(
                                      "div",
                                      { staticClass: "input-container" },
                                      [
                                        _c("input", {
                                          attrs: {
                                            type: "file",
                                            id: "classification",
                                            name: "upload_form_classification",
                                            accept: ".jpg, .pdf",
                                            required: this.newlyCreated,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.addFilesUpload(
                                                "upload_form_classification",
                                                _vm.classificationUploadId,
                                                "classificationPath"
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "actions flex items-center",
                                      },
                                      [
                                        _vm.existing &&
                                        _vm.existing.classification &&
                                        _vm.showUpload.includes(
                                          "classification"
                                        )
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "cancel",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toggleShowUpload(
                                                      "classification",
                                                      true
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.translations
                                                        .formLabels
                                                        .cancelUpdateDocument
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showUploadOk.includes("classificationPath")
                                ? _c("div", { staticClass: "mb-4" }, [
                                    _vm._v(
                                      "\n                            Fichier téléchargé. N'oubliez pas de valider.\n                        "
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "my-4 form-group form-group-radio" },
                          [
                            _c("label", { attrs: { for: "list-status-3" } }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.exhibitor.listStatus,
                                    expression: "exhibitor.listStatus",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  id: "list-status-3",
                                  disabled: _vm.allReadOnly,
                                },
                                domProps: {
                                  value: 3,
                                  checked: _vm._q(_vm.exhibitor.listStatus, 3),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.exhibitor,
                                      "listStatus",
                                      3
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", {
                                class: `checkmark checkbox ${
                                  this.newlyCreated &&
                                  _vm.exhibitor.listStatus === null
                                    ? "highlighted"
                                    : ""
                                }`,
                              }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.translations.formLabels.listStatus3
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "my-4 form-group form-group-radio" },
                          [
                            _c("label", { attrs: { for: "list-status-2" } }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.exhibitor.listStatus,
                                    expression: "exhibitor.listStatus",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  id: "list-status-2",
                                  disabled: _vm.allReadOnly,
                                },
                                domProps: {
                                  value: 2,
                                  checked: _vm._q(_vm.exhibitor.listStatus, 2),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.exhibitor,
                                      "listStatus",
                                      2
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", {
                                class: `checkmark checkbox ${
                                  this.newlyCreated &&
                                  _vm.exhibitor.listStatus === null
                                    ? "highlighted"
                                    : ""
                                }`,
                              }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.translations.formLabels.listStatus2
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "mainLoginForm",
                  staticClass: "create-exhibitor-form login-form",
                },
                [
                  _c(
                    "div",
                    {
                      class: `form-group ${
                        _vm.errorsFields.includes("title") ? "error" : ""
                      }`,
                    },
                    [
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(_vm._s(_vm.translations.formLabels.name) + "*"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.exhibitor.title,
                            expression: "exhibitor.title",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { disabled: this.hasId },
                        domProps: { value: _vm.exhibitor.title },
                        on: {
                          keyup: function ($event) {
                            return _vm.checkKeyForm(
                              "title",
                              _vm.exhibitor.title
                            )
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.exhibitor,
                              "title",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: `form-group ${
                        _vm.errorsFields.includes("zipcode") ? "error" : ""
                      }`,
                    },
                    [
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(
                          _vm._s(_vm.translations.formLabels.zipcode) + "*"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.exhibitor.zipcode,
                            expression: "exhibitor.zipcode",
                          },
                        ],
                        staticClass: "form-control js-zipcode",
                        attrs: { disabled: this.hasId },
                        domProps: { value: _vm.exhibitor.zipcode },
                        on: {
                          keyup: function ($event) {
                            return _vm.checkKeyForm(
                              "zipcode",
                              _vm.exhibitor.zipcode
                            )
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.exhibitor,
                              "zipcode",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: `form-group ${
                        _vm.errorsFields.includes("city") ? "error" : ""
                      }`,
                    },
                    [
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(_vm._s(_vm.translations.formLabels.city) + "*"),
                      ]),
                      _vm._v(" "),
                      !_vm.exhibitor.city
                        ? _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.exhibitor.city,
                                  expression: "exhibitor.city",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { disabled: this.hasId },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.exhibitor,
                                      "city",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function ($event) {
                                    return _vm.checkKeyForm(
                                      "city",
                                      _vm.exhibitor.city
                                    )
                                  },
                                ],
                              },
                            },
                            _vm._l(_vm.cities, function (city, index) {
                              return _c(
                                "option",
                                { key: index, domProps: { value: city.nom } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(city.nom) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.exhibitor.city,
                                expression: "exhibitor.city",
                              },
                            ],
                            staticClass: "form-control js-zipcode",
                            attrs: {
                              disabled: this.hasId && _vm.exhibitor.city,
                            },
                            domProps: { value: _vm.exhibitor.city },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.exhibitor,
                                  "city",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: `form-group ${
                        _vm.errorsFields.includes("selectedPriceGroupId")
                          ? "error"
                          : ""
                      }`,
                    },
                    [
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.translations.formLabels.selectedPriceGroup
                          ) + "*"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedPriceGroupId,
                              expression: "selectedPriceGroupId",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { disabled: this.hasId },
                          on: {
                            change: [
                              function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.selectedPriceGroupId = $event.target
                                  .multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                              function ($event) {
                                return _vm.checkKeyForm(
                                  "selectedPriceGroupId",
                                  _vm.selectedPriceGroupId
                                )
                              },
                            ],
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }),
                          _vm._v(" "),
                          _vm._l(_vm.priceGroupsToShow, function (priceGroup) {
                            return _c(
                              "option",
                              {
                                key: priceGroup.id,
                                domProps: { value: priceGroup.id },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(priceGroup.title) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  this.selectedPriceGroupId &&
                  this.selectedPriceGroupId === this.showVariationsFor
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            class: `form-group ${
                              _vm.errorsFields.includes("selectedVariationId")
                                ? "error"
                                : ""
                            }`,
                          },
                          [
                            _c("label", { staticClass: "control-label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.translations.formLabels.selectedVariation
                                ) + "*"
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedVariationId,
                                    expression: "selectedVariationId",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { disabled: this.hasId },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.selectedVariationId = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    function ($event) {
                                      return _vm.checkKeyForm(
                                        "selectedVariationId",
                                        _vm.selectedVariationId
                                      )
                                    },
                                  ],
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.variationOptions,
                                  function (variation) {
                                    return _c(
                                      "option",
                                      {
                                        key: variation.id,
                                        domProps: { value: variation.id },
                                      },
                                      [
                                        _c("div", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              variation.description
                                            ),
                                          },
                                        }),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  this.newlyCreated
                    ? _c("div", [
                        _c("div", { staticClass: "newly-created-info" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.translations.formLabels.newlyCreatedInfo
                              ) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "upload-form" }, [
                          _c("label", { attrs: { for: "kbis" } }, [
                            _vm._v(
                              _vm._s(_vm.translations.formLabels.uploadKbis)
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.existing &&
                          _vm.existing.kbis &&
                          !_vm.showUpload.includes("kbis")
                            ? _c("div", { staticClass: "existing-actions" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "button mr-2",
                                    on: {
                                      click: function ($event) {
                                        return _vm.download(_vm.existing.kbis)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.translations.formLabels.download
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.allReadOnly
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "button",
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleShowUpload("kbis")
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.translations.formLabels
                                                .updateDocument
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !(_vm.existing && _vm.existing.kbis) ||
                          _vm.showUpload.includes("kbis")
                            ? _c("div", [
                                _c("div", { staticClass: "input-container" }, [
                                  _c("input", {
                                    attrs: {
                                      type: "file",
                                      id: "kbis",
                                      name: "upload_form_kbis",
                                      required: "",
                                      accept: ".jpg, .pdf",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.addFilesUpload(
                                          "upload_form_kbis",
                                          _vm.kbisUploadId,
                                          "kbisPath"
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "actions flex items-center" },
                                  [
                                    _vm.existing &&
                                    _vm.existing.kbis &&
                                    _vm.showUpload.includes("kbis")
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "cancel",
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleShowUpload(
                                                  "kbis",
                                                  true
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.translations.formLabels
                                                    .cancelUpdateDocument
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showUploadOk.includes("kbisPath")
                            ? _c("div", { staticClass: "mb-4" }, [
                                _vm._v(
                                  "\n                            Fichier téléchargé. N'oubliez pas de valider.\n                        "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "upload-form" }, [
                          _c("label", { attrs: { for: "insurance" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.translations.formLabels.uploadInsurance
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.existing &&
                          _vm.existing.insurance &&
                          !_vm.showUpload.includes("insurance")
                            ? _c("div", { staticClass: "existing-actions" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "button mr-2",
                                    on: {
                                      click: function ($event) {
                                        return _vm.download(
                                          _vm.existing.insurance
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.translations.formLabels.download
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.allReadOnly
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "button",
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleShowUpload(
                                              "insurance"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.translations.formLabels
                                                .updateDocument
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !(_vm.existing && _vm.existing.insurance) ||
                          _vm.showUpload.includes("insurance")
                            ? _c("div", [
                                _c("div", { staticClass: "input-container" }, [
                                  _c("input", {
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "file",
                                      id: "insurance",
                                      required: "",
                                      name: "upload_form_insurance",
                                      accept: ".jpg, .pdf",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.addFilesUpload(
                                          "upload_form_insurance",
                                          _vm.insuranceUploadId,
                                          "insurancePath"
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "actions flex items-center" },
                                  [
                                    _vm.existing &&
                                    _vm.existing.insurance &&
                                    _vm.showUpload.includes("insurance")
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "cancel",
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleShowUpload(
                                                  "insurance",
                                                  true
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.translations.formLabels
                                                    .cancelUpdateDocument
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showUploadOk.includes("insurancePath")
                            ? _c("div", [
                                _vm._v(
                                  "\n                            Fichier téléchargé. N'oubliez pas de valider.\n                        "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ])
                    : _c(
                        "div",
                        { staticClass: "my-4 form-group form-group-checkbox" },
                        [
                          _c("label", { attrs: { for: "is-up-to-date" } }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.exhibitor.isUpToDate,
                                  expression: "exhibitor.isUpToDate",
                                },
                              ],
                              attrs: {
                                type: "checkbox",
                                id: "is-up-to-date",
                                required: "",
                                disabled: _vm.allReadOnly,
                              },
                              domProps: {
                                checked: Array.isArray(_vm.exhibitor.isUpToDate)
                                  ? _vm._i(_vm.exhibitor.isUpToDate, null) > -1
                                  : _vm.exhibitor.isUpToDate,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.exhibitor.isUpToDate,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.exhibitor,
                                          "isUpToDate",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.exhibitor,
                                          "isUpToDate",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.exhibitor, "isUpToDate", $$c)
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", {
                              class: `checkmark checkbox ${
                                !_vm.exhibitor.isUpToDate ? "highlighted" : ""
                              }`,
                            }),
                            _vm._v(
                              "\n\n                        " +
                                _vm._s(_vm.translations.formLabels.isUpToDate) +
                                "\n                    "
                            ),
                          ]),
                        ]
                      ),
                  _vm._v(" "),
                  !_vm.allReadOnly
                    ? _c(
                        "button",
                        {
                          staticClass: "mt-8 button",
                          attrs: {
                            type: "submit",
                            disabled: _vm.disabledButton,
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.translations.formLabels.formSubmit) +
                              "\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }